// src/pages/Dashboard/Finance/Payroll/TotalExpenses.jsx
import React from "react";
import { Grid, Paper, Box, Typography } from "@mui/material";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
} from "recharts";
import { useTranslation } from "react-i18next";

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <Paper
        sx={{
          padding: "8px",
          borderRadius: 2,
          backgroundColor: "#fff",
          boxShadow: 2,
        }}
      >
        <Typography variant="body2" color="textSecondary">
          {label}
        </Typography>
        <Typography variant="h6" color="primary">
          {`${payload[0].value.toLocaleString()}؋`}
        </Typography>
      </Paper>
    );
  }
  return null;
};

const TotalExpenses = ({ payrollAndExpensesData = {} }) => {
  const { t } = useTranslation();
  const data = [
    { name: t("finance.totalPayroll"), value: Number(payrollAndExpensesData.total_payroll) || 0 },
    { name: t("finance.totalExpenses"), value: Number(payrollAndExpensesData.total_expenses) || 0 },
  ];

  return (
    <Grid container>
      <Paper sx={{ width: "100%", padding: 3, borderRadius: 2, boxShadow: 3 }}>
        <Box textAlign="center" mb={2}>
          <Typography variant="h5" fontWeight="bold" color="primary">
            {t("finance.payrollExpenses")}
          </Typography>
        </Box>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" strokeOpacity={0.3} />
            <XAxis dataKey="name" tick={{ fill: "#555", fontWeight: "bold" }} />
            <YAxis tick={{ fill: "#555", fontWeight: "bold" }} />
            <Tooltip content={<CustomTooltip />} cursor={{ fill: "rgba(200,200,200,0.3)" }} />
            <Legend verticalAlign="top" align="right" iconType="circle" />
            <Line type="monotone" dataKey="value" stroke="#1976d2" strokeWidth={3} dot={{ r: 5 }} name={t("finance.value")} />
          </LineChart>
        </ResponsiveContainer>
      </Paper>
    </Grid>
  );
};

export default TotalExpenses;
